//import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { InvoiceService } from "src/app/services/http/business/invoice/invoice.service";
import { PaymentService } from "src/app/services/http/business/payment/payment.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { CouponService } from "src/app/services/http/business/coupon/coupon.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { CashService } from "src/app/services/http/business/cash/cash.service";
import { IPaymentation } from "src/app/interfaces/paymentation";
//import { BIDService } from "src/app/services/common/bid.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { CIDService } from "src/app/services/common/cid.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-invoice-summary",
  templateUrl: "./invoice-summary.component.html",
  styleUrls: ["./invoice-summary.component.css"]
})
export class InvoiceSummaryComponent implements OnInit {
  form: FormGroup;
  invoiceDetail: any;
  coupon: number = 0;
  invoiceId: number;
  isPay = false;
  couponList = [];
  credit: number;
  remainResult: any;
  cashList = [];
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  queryParams: {};
  CompanyEncryptId: any;
  activeBank: any;


  constructor(
    private fb: FormBuilder,
    private paymentService: PaymentService,
    private snackBar: SnackBarService,
    private translate: TranslateService,
    private invoiceService: InvoiceService,
    private couponService: CouponService,
    private cashService: CashService,
    private studentService: StudentService,
    //private bidService: BIDService,
    private errorService: ErrorsService,
    private cidService: CIDService,
    public translateService: TranslateService,
    private dialogRef: MatDialogRef<InvoiceSummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

  ) { }

  ngOnInit() {
    console.log(this.data);

    this.cteateForm();
    // this.route.params.subscribe(res => {
    this.invoiceId = this.data.Id;

    if (this.data.IsStudent)
      this.getinvoiceDetailStudent();
    else
      this.getinvoiceDetail();

    this.getActiveBank(this.data.Id);
  }

  cteateForm() {
    this.form = this.fb.group({
      walletPay: [false],
      coupons: [null],
      cashId: [null],
      TrackingCode: [null]
    });
  }
  // برای کاربران غیر دانشجو
  getinvoiceDetail() {
    var _data = this.data;
    this.invoiceService.invoiceCompanyGetById(_data.Id).subscribe(res => {
      this.invoiceDetail = res.DataList.filter(function (e) {
        return e.Id == _data.Id
      })[0];
      this.CompanyEncryptId = this.invoiceDetail.CompanyEncryptId;
      this.getUserCoupons();
      this.getWallet();
      this.calcPaymentCashemaining(null);
      this.getCashiers();
    });

  }
  // برای کاربران غیر دانشجو
  getWallet() {
    this.paymentService.getWallet(this.invoiceDetail.NationalCode).subscribe(
      res => {
        this.credit = res.CreditCompany;
      },
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.getWallet"),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    );
  }

  // برای کاربران دانشجو
  getinvoiceDetailStudent() {
    var _data = this.data;
    this.studentService.getInvoiceComonSTU(this.data.Id).subscribe(res => {
      this.invoiceDetail = res.DataList.filter(function (e) {
        return e.Id == _data.Id
      })[0];
      debugger
      this.cidService.setCID(this.invoiceDetail.CompanyEncryptId);
      this.queryParams = {
        CompanyEncryptId: this.invoiceDetail.CompanyEncryptId
      };
      this.CompanyEncryptId = this.invoiceDetail.CompanyEncryptId;
      this.getWalletStudent();
      this.calcPaymentCashemainingStudent(null);
      this.getUserCouponsStudent();
    });

  }
  // برای کاربران دانشجو
  getWalletStudent() {

    this.paymentService.getWalletSTU(this.queryParams).subscribe(
      res => {

        this.credit = res.CreditCompany;
      },
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.getWallet"),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    );
  }

  // برای کاربران دانشجو
  calcPaymentCashemainingStudent(data: any) {
    this.errors = [];
    var model = {};
    if (data) {
      model = {
        ListCouponId: data.coupons ? [data.coupons] : [],
        CompanyDiscount: data.walletPay ? this.credit : 0,
        NationalCode: this.invoiceDetail.NationalCode,
        Id: this.data.Id
      }
    }
    else {
      model = {
        ListCouponId: [],
        CompanyDiscount: 0,
        NationalCode: this.invoiceDetail.NationalCode,
        Id: this.data.Id
      }
    }

    this.paymentService.paymentCashemaininSTU(model).subscribe(res => {

      this.remainResult = res;
    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    })

  }

  // برای کاربران دانشجو
  getUserCouponsStudent() {
    var branch = this.invoiceDetail.BranchName;
    this.couponService.getListUserSTU(this.queryParams).subscribe(res => {
      if (branch == "آموزش از راه دور (آموزش آنلاين)" || branch == "فرانسه") {
        this.couponList = res.DataList.filter(function (el) {
          return el.CouponCode != '0013991112'
        });
      }
      else
        this.couponList = res.DataList;
    }, () => {

    })
  }

  clearCoupon(data: any) {
    this.form.value.coupons = [];
    data.coupons = null;
    this.calcPaymentCashemaining(data);
  }

  calcPaymentCashemaining(data: any) {
    this.errors = [];
    var model = {};
    if (data) {
      model = {
        ListCouponId: data.coupons ? [data.coupons] : [],
        CompanyDiscount: data.walletPay ? this.credit : 0,
        NationalCode: this.invoiceDetail.NationalCode,
        Id: this.data.Id
      }
    }
    else {
      model = {
        ListCouponId: [],
        CompanyDiscount: 0,
        NationalCode: this.invoiceDetail.NationalCode,
        Id: this.data.Id
      }
    }

    console.log(model);
    this.paymentService.paymentCashemaining(model).subscribe(res => {
      console.log(res);
      this.remainResult = res;
    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    })

  }

  getCashiers() {
    this.cashService.list(this.invoiceDetail.BranchEncryptId, 0, 0).subscribe(res => {
      this.cashList = res.DataList.filter(function (element) {
        return element.IsActive;
      });;
    }, () => {
      this.snackBar.OpenSnackBar(
        this.translate.get("error.cashList"),
        "ok",
        5000,
        SoundEnum.beep
      );
    })
  }

  getActiveBank(invoiceId: number) {
    this.paymentService.GetActiveBank(invoiceId).subscribe(
      res => {
        this.activeBank = res
      },
      err => {
        this.snackBar.OpenSnackBar(
          err.error.returnValue,
          "ok",
          10000,
          SoundEnum.beep
        );
        this.isPay = false;
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  isActiveBank(xCode: string) {
    return this.activeBank.some(function (x) { return x.Code == xCode })
  }

  payment(data: any, bank: string) {
    let model = {
      ListCouponId: data.coupons ? [data.coupons] : [],
      CompanyDiscount: this.remainResult.CompanyDiscount,
      Id: this.invoiceId,
      IsStudent: this.data.IsStudent
    }
    this.paymentService.pay(model, bank).subscribe(
      res => {

        window.open(res.returnValue2, '_blank');
        //window.location.href = res.returnValue2;
      },
      err => {
        this.snackBar.OpenSnackBar(
          err.error.returnValue,
          "ok",
          10000,
          SoundEnum.beep
        );
        this.isPay = false;
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }



  settlement(data: any) {
    let model = {
      ListCouponId: data.coupons ? [data.coupons] : [],
      CompanyDiscount: this.remainResult.CompanyDiscount,
      Id: this.invoiceId
    }
    this.paymentService.pay(model, 'melli').subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.settelment"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialogRef.close();
      },
      err => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.settelment"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.isPay = false;
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  paymentation(data: any, pos: boolean = false) {
    console.log(pos);

    var model: IPaymentation = {
      Id: this.data.Id,
      ListCouponId: data.coupons ? [data.coupons] : [],
      CashAmount: this.remainResult.Remaining,
      CashId: data.cashId,
      NationalCode: this.invoiceDetail.NationalCode,
      CompanyDiscount: this.remainResult.CompanyDiscount,
      BranchEncryptId: null,
      PoseItem: null
    };
    this.paymentService.paymentation(model).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.paymentCash"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialogRef.close();
        //this.router.navigate(["management/finance/invoice"]);
      },
      err => {
        console.log(err);

        this.snackBar.OpenSnackBar(
          this.translate.get("error.paymentCash"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.isPay = false;
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }


  paymentationPos(data: any) {

    var model: IPaymentation = {
      Id: this.data.Id,
      ListCouponId: data.coupons ? [data.coupons] : [],
      CashAmount: 0,
      CashId: data.cashId,
      BranchEncryptId: this.invoiceDetail.BranchEncryptId,
      NationalCode: this.invoiceDetail.NationalCode,
      CompanyDiscount: this.remainResult.CompanyDiscount,
      PoseItem: {
        TrackingCode: data.TrackingCode,
        PoseAmount: this.remainResult.Remaining
      }
    };
    this.paymentService.paymentation(model).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.paymentCash"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialogRef.close();
        //this.router.navigate(["management/finance/invoice"]);
      },
      err => {
        console.log(err);

        this.snackBar.OpenSnackBar(
          this.translate.get("error.paymentCash"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.isPay = false;
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }



  getUserCoupons() {
    var branch = this.invoiceDetail.BranchName;
    this.couponService.listUser(this.invoiceDetail.NationalCode, this.CompanyEncryptId, 0, 0, 0).subscribe(res => {
      if (branch == "آموزش از راه دور (آموزش آنلاين)" || branch == "فرانسه") {
        this.couponList = res.DataList.filter(function (el) {
          return el.CouponCode != '0013991112'
        });
      }
      else
        this.couponList = res.DataList;
    }, () => {

    })
  }


  onCancel() {
    this.dialogRef.close();
    //this.router.navigate(["management/finance/invoice"]);
  }
}
